<template>
    <div>Page introuvable, redirection...</div>
</template>

<script>
export default {
    created: function() {
        // Redirect outside the app using plain old javascript
        // setTimeout(() => {
            this.$router.push({ name: 'accueil' });
        // }, 5000)
    }
}
</script>
